<template>
  <div class="organizational-structure-menu">

    <OrganizationalStructureMenuItem
      v-for="map in oscInstance.__levelNameMap"
      :ref="refMap(map.key)"
      :key="map.key"
      :label="map.levelName"
      :obj-key="map.key"
      :onChange="onChange"
      :onClear="oscInstance.onClearOrganizationalStructureLevelSelect"
    />
    <div class="row justify-evenly">
      <q-btn class="col-5" size="sm" color="grey-7" v-close-popup>{{
        $gettext('CANCEL')
      }}</q-btn>
      <q-btn
        class="col-5"
        size="sm"
        color="info"
        v-close-popup
        @click="onSaveHandler"
        >{{ $gettext('SAVE') }}</q-btn
      >
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import OrganizationalStructureMenuItem from './OrganizationalStructureMenuItem.vue'
import { OrganizationalStructureController } from './OrganizationalStructureController'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    OrganizationalStructureMenuItem
  },
  props: {}
})
export default class OrganizationalStructureMenu extends Vue {
  oscInstance = OrganizationalStructureController.getInstance()

  refMap (map) {
    return `ref${map}`
  }

  onChange (value) {
    this.oscInstance.onOrganizationalStructureLevelSelect(value)
  }

  onSaveHandler () {
    this.oscInstance.onSave()
  }
}
</script>
<style>
.organizational-structure-line {
  display: flex;
}
</style>
